import { AuthService } from '@obo-main/services/auth/auth.service';

/**
 * Factory to setup the authservice
 * @param config
 */
export function AuthServiceFactory(authService: AuthService): Promise<void> {
    return authService.initializeAuth();
}
